// Do not add vue content nor http requests in this file as it is used in ckeditor model plugin
import { IMediaType } from '~/entities/content/media/interfaces/media-type'

import { IContentModel } from '~/features-shared/content/interfaces/content-model'

export const MEDIA_ICON_MATRIX: Partial<Record<IMediaType, string>> = {
  [IMediaType.AnimatedPicture]: 'picture-animated',
  [IMediaType.Document]: 'doc',
  [IMediaType.Sketch]: 'app-3dsketch',
  [IMediaType.Story]: 'app-3dstory',
  [IMediaType.Whiteboard]: 'app-whiteboard',
  [IMediaType.Simulation]: 'run',
  [IMediaType.Model3D]: 'cube',
  [IMediaType.Picture]: 'picture',
  [IMediaType.HomeByMe]: 'logo-homebyme',
}

export const CONTENT_ICON: Partial<Record<IContentModel, { color: string, icon: string }>> = {
  [IContentModel.Question]: { icon: 'comment-question', color: 'text-color-question' },
  [IContentModel.Idea]: { icon: 'lamp', color: 'text-color-idea' },
  [IContentModel.Wiki]: { icon: 'book-open', color: 'text-color-wiki' },
  [IContentModel.Conference]: { icon: 'calendar', color: 'text-color-conference' },
  [IContentModel.Wedo]: { icon: 'task', color: 'text-color-wedo' },
  [IContentModel.Survey]: { icon: 'clipboard', color: 'text-color-survey' },
  [IContentModel.Post]: { icon: 'newspaper', color: 'text-color-post' },
  [IContentModel.Media]: { icon: 'picture', color: 'text-color-media' },
}
